import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { loginErrorMessage } from './login-error';

type LoginState = {
  email: string;
  setEmail: (v: string) => void;
  password: string;
  setPassword: (v: string) => void;
  error: string;
  loading: boolean;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
};

export function useLogin(): LoginState {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [status, setStatus] = useState({ error: '', loading: false });
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();

  function handleSubmit(e: FormEvent<HTMLFormElement>): void {
    e.preventDefault();
    setStatus({ error: '', loading: true });
    login(email, password)
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) =>
        setStatus({ error: loginErrorMessage(err), loading: false })
      );
  }

  return {
    email,
    setEmail,
    password,
    setPassword,
    error: status.error,
    loading: status.loading,
    handleSubmit,
  };
}
